export default function Currency() {
    return <i className={"text-sm text-center fas fa-rupee-sign"} />
}